module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/core-js/2.4.1/core-js/library/modules/_is-object.js
// module id = 67
// module chunks = 0